import React from "react";
import { motion } from "framer-motion";
import { FaHandshake, FaCarSide, FaCreditCard, FaPercent, FaCanadianMapleLeaf, FaClock } from "react-icons/fa";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

const Services = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white text-gray-800">
      {/* 🌟 Hero Section */}
      <section
  className="relative py-28 px-6 text-center text-white"
  style={{
    backgroundImage:
      "linear-gradient(rgba(10,37,69,0.6), rgba(13,94,99,0.6)), url('/sr.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-extrabold tracking-wide mb-4"
        >
          Canada’s Most Trusted Auto Financing Partner
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-lg max-w-2xl mx-auto text-gray-200"
        >
          Simplifying car ownership with low-interest, fast approval, and complete transparency.
        </motion.p>
      </section>

      {/* 💳 Services Section */}
      <section className="py-24 px-10 md:px-20 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-4xl font-bold text-[#0a2545] mb-14"
        >
          Our Premium Services
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {[
            {
              icon: <FaHandshake className="text-4xl text-teal-400 mx-auto mb-4" />,
              title: "Fast & Easy Financing",
              desc: "Experience hassle-free car financing with instant approvals and minimal paperwork.",
            },
            {
              icon: <FaPercent className="text-4xl text-teal-400 mx-auto mb-4" />,
              title: "Lowest Interest Rates",
              desc: "We offer some of the most competitive interest rates in Canada’s auto market.",
            },
            {
              icon: <FaCarSide className="text-4xl text-teal-400 mx-auto mb-4" />,
              title: "1500+ Vehicles in Stock",
              desc: "Choose from our extensive collection of high-quality vehicles available for financing.",
            },
            {
              icon: <FaCreditCard className="text-4xl text-teal-400 mx-auto mb-4" />,
              title: "Bad Credit? Still Approved!",
              desc: "Even if your credit history isn’t perfect, we ensure fair approval and flexible terms.",
            },
            {
              icon: <FaCanadianMapleLeaf className="text-4xl text-teal-400 mx-auto mb-4" />,
              title: "Proudly Canadian",
              desc: "We’re a Canada-based financing company supporting drivers nationwide with integrity.",
            },
            {
              icon: <FaClock className="text-4xl text-teal-400 mx-auto mb-4" />,
              title: "Quick Turnaround",
              desc: "Get approved within 24 hours and drive your dream car faster than ever.",
            },
          ].map((service, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              whileInView={{ opacity: 1, y: 0 }}
              initial={{ opacity: 0, y: 30 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-[#0A2545] text-white rounded-3xl p-8 shadow-2xl hover:shadow-teal-400/30 border border-teal-400 transition-all"
            >
              {service.icon}
              <h3 className="text-xl font-semibold mb-3">{service.title}</h3>
              <p className="text-gray-300 text-sm">{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* 🚀 CTA Section */}
      <section className="text-center py-20 bg-gradient-to-r from-[#0a2545] to-[#0d5e63] text-white">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="text-3xl font-semibold mb-6"
        >
          Ready to Finance Your Next Car?
        </motion.h2>
        <p className="text-gray-300 mb-6">
          Apply today and experience the most seamless car financing in Canada.
        </p>
        <button
           onClick={() => navigate("/", { state: { openApply: true } })}
          className="px-10 py-4 bg-teal-400 text-[#0a2545] font-semibold rounded-full shadow-lg hover:bg-white hover:text-[#0a2545] transition-all"
        >
          Apply for Financing
        </button>

      </section>
      <div className="mb-24"></div>

     
    </div>
  );
};

export default Services;
